import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "components-spinner-box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "components-pulse-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "components-pulse-bubble components-pulse-bubble-1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "components-pulse-bubble components-pulse-bubble-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "components-pulse-bubble components-pulse-bubble-3" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3, 512)), [
    [_vShow, _ctx.isShow]
  ])
}